<template>
  <div class="mailList">
    <div>
      <el-button :class="{active:Type===1}" @click="toPage('/org/mail/mailList',1)">我接收的</el-button>
      <el-button :class="{active:Type===0}" @click="toPage('/org/mail/mailList2',0)">我发送的</el-button>

    </div>
    <div>
      <router-view @setType="setType"/>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        Type:1
      }
    },
    computed: {

    },
    created() {


    },
    methods: {
      toPage(router,i){
        this.$router.replace(router)
        this.Type = i
      },
      setType(type) {
        this.Type = type
      }
    },
    components: {
    },
  }
</script>

<style scoped lang="scss">
  .mailList {
    width: 1200px;
    margin: 20px auto 0;
    .active{
      background: #00a2ea;
      color: #fff;
    }
  }
</style>